import { render, staticRenderFns } from "./EditScopes.vue?vue&type=template&id=dc1283c0&"
import script from "./EditScopes.vue?vue&type=script&lang=js&"
export * from "./EditScopes.vue?vue&type=script&lang=js&"
import style0 from "./EditScopes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports